var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"batches-protocols","route":"/reports/billing-batches-protocols","file-name":"protocolos-de-envio.xlsx","period-label":"Período de envio do lote","columns":_vm.columns,"status-options":_vm.statusOptions,"show-status":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }